/**
 * Poseedores API
 * Poseedores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoseedorFilterDTO } from './poseedorFilterDTO';
import { IdEntityFilterDTO } from './idEntityFilterDTO';


export interface FacturaPoseedorFilterDTO { 
    id?: number;
    poseedor?: PoseedorFilterDTO;
    numeroAutofactura?: number;
    fechaAutofactura?: string;
    numeroFactura?: string;
    fechaFactura?: string;
    estado?: IdEntityFilterDTO;
    origen?: FacturaPoseedorFilterDTO.OrigenEnum;
    anioPrefactura?: number;
    registrada?: boolean;
    abono?: string;
}
export namespace FacturaPoseedorFilterDTO {
    export type OrigenEnum = 'POSEEDORES' | 'PUNTOSRECOGIDA' | 'SDDRCC' | 'SDDRCA' | 'ADHERIDO' | 'GESTORESACUERDO' | 'CVF';
    export const OrigenEnum = {
        Poseedores: 'POSEEDORES' as OrigenEnum,
        Puntosrecogida: 'PUNTOSRECOGIDA' as OrigenEnum,
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Adherido: 'ADHERIDO' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum,
        Cvf: 'CVF' as OrigenEnum
    };
}


